// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f97d1afd","396":"00d75391","453":"996d50a8","455":"00080e90","970":"f065bdd5","977":"882b2b7b"}[chunkId] + ".chunk.js";
};